

export default class UserPaymentDetailsDTO {

    constructor(jsonResponse) {

        this.id = jsonResponse["id"];
        this.userId = jsonResponse["user-id"];
        this.creatingUserId = jsonResponse["creating-user-id"];
        this.paymentTypeDetailsId = jsonResponse["payment-type-details-id"];
        this.dateCreated = jsonResponse["date-created"];
        this.bankName = jsonResponse["bank-name"];
        this.bankAccountNumber = jsonResponse["bank-account-number"];
        this.branchCode = jsonResponse["branch-code"];
        this.walletName = jsonResponse["wallet-name"];
        this.msisdn = jsonResponse["msisdn"];
        this.userPaymentType = jsonResponse["user-payment-type"];
        this.active = jsonResponse["active"];
    }

    static toJson = function (item) {

        let jsonObj = {};

        jsonObj["id"] = item.id;
        jsonObj["user-id"] = item.userId;
        jsonObj["creating-user-id"] = item.creatingUserId;
        jsonObj["payment-type-details-id"] = item.paymentTypeDetailsId;
        jsonObj["bank-name"] = item.bankName;
        jsonObj["bank-account-number"] = item.bankAccountNumber;
        jsonObj["branch-code"] = item.branchCode;
        jsonObj["wallet-name"] = item.walletName;
        jsonObj["msisdn"] = item.msisdn;
        jsonObj["user-payment-type"] = item.userPaymentType;
        jsonObj["active"] = item.active;

        return jsonObj;
    };

}
